module.exports = "/_next/static/images/dot grid-da6daf780054592478bac8e7684eaada.svg";